export const products = [
  // Gold Collection
  {
    id: 1,
    name: "Royal Heritage Gold Necklace",
    category: "Gold",
    collection: "Bridal",
    price: 285000,
    originalPrice: 320000,
    discount: 11,
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=500",
    images: [
      "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=500",
      "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=500"
    ],
    rating: 4.8,
    reviews: 124,
    description: "Exquisite 22K gold necklace with traditional Indian design, perfect for weddings and special occasions.",
    weight: "45g",
    purity: "22K",
    inStock: true,
    trending: true,
    featured: true
  },
  {
    id: 2,
    name: "Diamond Studded Gold Bangles",
    category: "Gold",
    collection: "Diamond",
    price: 195000,
    originalPrice: 215000,
    discount: 9,
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=500",
    images: [
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=500",
      "https://images.unsplash.com/photo-1535632787350-4e68ef0ac584?w=500"
    ],
    rating: 4.9,
    reviews: 89,
    description: "Elegant gold bangles adorned with premium diamonds, a perfect blend of tradition and luxury.",
    weight: "35g",
    purity: "22K",
    inStock: true,
    trending: true,
    featured: false
  },
  {
    id: 3,
    name: "Antique Gold Jhumkas",
    category: "Gold",
    collection: "Traditional",
    price: 45000,
    originalPrice: 52000,
    discount: 13,
    image: "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=500",
    images: [
      "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=500",
      "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=500"
    ],
    rating: 4.7,
    reviews: 156,
    description: "Traditional antique finish gold jhumkas with intricate design work.",
    weight: "15g",
    purity: "22K",
    inStock: true,
    trending: false,
    featured: true
  },

  // Diamond Collection
  {
    id: 4,
    name: "Solitaire Diamond Ring",
    category: "Diamond",
    collection: "Engagement",
    price: 425000,
    originalPrice: 475000,
    discount: 11,
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=500",
    images: [
      "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=500",
      "https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=500"
    ],
    rating: 5.0,
    reviews: 234,
    description: "1.5 carat solitaire diamond ring in 18K white gold setting.",
    weight: "5g",
    purity: "18K",
    carat: "1.5ct",
    clarity: "VVS1",
    inStock: true,
    trending: true,
    featured: true
  },
  {
    id: 5,
    name: "Diamond Tennis Bracelet",
    category: "Diamond",
    collection: "Luxury",
    price: 580000,
    originalPrice: 650000,
    discount: 11,
    image: "https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=500",
    images: [
      "https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=500",
      "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=500"
    ],
    rating: 4.9,
    reviews: 178,
    description: "Stunning tennis bracelet with 3 carats of brilliant cut diamonds.",
    weight: "12g",
    purity: "18K",
    carat: "3ct",
    clarity: "VS1",
    inStock: true,
    trending: true,
    featured: false
  },
  {
    id: 6,
    name: "Diamond Chandelier Earrings",
    category: "Diamond",
    collection: "Bridal",
    price: 320000,
    originalPrice: 360000,
    discount: 11,
    image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=500",
    images: [
      "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=500",
      "https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=500"
    ],
    rating: 4.8,
    reviews: 145,
    description: "Exquisite chandelier earrings with cascading diamonds.",
    weight: "8g",
    purity: "18K",
    carat: "2ct",
    clarity: "VS2",
    inStock: true,
    trending: false,
    featured: true
  },

  // Silver Collection
  {
    id: 7,
    name: "Sterling Silver Anklets",
    category: "Silver",
    collection: "Traditional",
    price: 12000,
    originalPrice: 15000,
    discount: 20,
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=500",
    images: [
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=500",
      "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=500"
    ],
    rating: 4.6,
    reviews: 267,
    description: "Traditional sterling silver anklets with ghungroo bells.",
    weight: "25g",
    purity: "925",
    inStock: true,
    trending: false,
    featured: false
  },
  {
    id: 8,
    name: "Silver Temple Jewellery Set",
    category: "Silver",
    collection: "Traditional",
    price: 35000,
    originalPrice: 42000,
    discount: 17,
    image: "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=500",
    images: [
      "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=500",
      "https://images.unsplash.com/photo-1535632787350-4e68ef0ac584?w=500"
    ],
    rating: 4.7,
    reviews: 189,
    description: "Complete temple jewellery set in oxidized silver finish.",
    weight: "85g",
    purity: "925",
    inStock: true,
    trending: true,
    featured: false
  },

  // Platinum Collection
  {
    id: 9,
    name: "Platinum Love Bands",
    category: "Platinum",
    collection: "Engagement",
    price: 65000,
    originalPrice: 75000,
    discount: 13,
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=500",
    images: [
      "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=500",
      "https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=500"
    ],
    rating: 4.9,
    reviews: 342,
    description: "Matching platinum love bands with diamond accents.",
    weight: "10g",
    purity: "95%",
    inStock: true,
    trending: true,
    featured: true
  },
  {
    id: 10,
    name: "Rose Gold Diamond Pendant",
    category: "Gold",
    collection: "Modern",
    price: 78000,
    originalPrice: 88000,
    discount: 11,
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=500",
    images: [
      "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=500",
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=500"
    ],
    rating: 4.8,
    reviews: 198,
    description: "Modern rose gold pendant with diamond cluster design.",
    weight: "6g",
    purity: "18K",
    carat: "0.5ct",
    inStock: true,
    trending: false,
    featured: true
  },
  {
    id: 11,
    name: "Pearl & Gold Choker",
    category: "Gold",
    collection: "Bridal",
    price: 165000,
    originalPrice: 185000,
    discount: 11,
    image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=500",
    images: [
      "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=500",
      "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=500"
    ],
    rating: 4.7,
    reviews: 156,
    description: "Elegant choker with south sea pearls and gold detailing.",
    weight: "32g",
    purity: "22K",
    inStock: true,
    trending: true,
    featured: false
  },
  {
    id: 12,
    name: "Kundan Maang Tikka",
    category: "Gold",
    collection: "Bridal",
    price: 28000,
    originalPrice: 32000,
    discount: 13,
    image: "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=500",
    images: [
      "https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=500",
      "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=500"
    ],
    rating: 4.8,
    reviews: 234,
    description: "Traditional kundan maang tikka with pearl drops.",
    weight: "12g",
    purity: "22K",
    inStock: true,
    trending: false,
    featured: true
  }
];

export const categories = [
  { id: 1, name: "All", value: "all" },
  { id: 2, name: "Gold", value: "Gold" },
  { id: 3, name: "Diamond", value: "Diamond" },
  { id: 4, name: "Silver", value: "Silver" },
  { id: 5, name: "Platinum", value: "Platinum" }
];

export const collections = [
  { id: 1, name: "Bridal", value: "Bridal" },
  { id: 2, name: "Traditional", value: "Traditional" },
  { id: 3, name: "Modern", value: "Modern" },
  { id: 4, name: "Luxury", value: "Luxury" },
  { id: 5, name: "Engagement", value: "Engagement" }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200",
    rating: 5,
    comment: "Absolutely stunning collection! The quality of gold and craftsmanship is exceptional. My wedding jewellery from Bharat Gold made my special day even more memorable.",
    date: "2024-01-15"
  },
  {
    id: 2,
    name: "Rahul Verma",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200",
    rating: 5,
    comment: "Excellent service and authentic jewellery. The diamond ring I purchased for my engagement was perfect. Highly recommended!",
    date: "2024-01-20"
  },
  {
    id: 3,
    name: "Anjali Patel",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200",
    rating: 5,
    comment: "The traditional gold collection is amazing. Every piece tells a story of heritage and elegance. Customer service is top-notch!",
    date: "2024-01-25"
  }
];